/**
 * 갤러리 상세 컴포넌트
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { MainLayout } from '../../../../shared/components';
import { BoardDetail } from '../../../../shared/components/Board/BoardDetail/BoardDetail';
import { useBoardDetail } from '../../../../shared/hooks';
import styled from '@emotion/styled';
import { theme } from '../../../../shared/styles/theme';

const PageContainer = styled.div`
  padding: ${theme.spacing.xl} ${theme.spacing.lg};
`;

export const GalleryDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // React Query로 게시글 상세 조회 (자동 캐싱)
  const { data: post, isLoading } = useBoardDetail('gallery', id ? Number(id) : undefined);

  const handleBack = () => {
    navigate('/community/gallery');
  };

  if (!post) {
    return (
      <MainLayout>
        <PageContainer></PageContainer>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <BoardDetail post={post} onBack={handleBack} />
    </MainLayout>
  );
};
